import React from 'react';
import IngredientIcon from './IngredientIcon';
import './Ingredients.less';

class Ingredients extends React.Component {
  render () {
    return (
      <section className="section section-ingredients">
        <div className="container-limit">
          <div className="ingredients-pics-panel ingredients-pics-panel-1">
            <IngredientIcon className="ingredient-icon-carrot" />
            <IngredientIcon className="ingredient-icon-beet" />
          </div>
          <div className="container">
            <h1>Sekret naszego borszczu</h1>
            <div className="grid-sm-2">
              <article className="story">
                <p>
                  Gotujemy tylko z <strong>naturalnych</strong> składników:
                </p>
                <ul>
                  <li>wołowina i wieprzowina najlepszej kategorii</li>
                  <li>swieże warzywa</li>
                  <li>ziola</li>
                  <li>przyprawy</li>
                </ul>
              </article>
              <IngredientIcon className="ingredient-icon-cow" />
              <article className="story">
                <p>Nie używamy <strong>żadnych</strong> dodatków sztucznych.</p>
                <p>Z tego wychodzi <strong>prawdziwy borszcz</strong></p>
              </article>
            </div>
          </div>
          <div className="ingredients-pics-panel ingredients-pics-panel-2">
            <IngredientIcon className="ingredient-icon-cabbage" />
            <IngredientIcon className="ingredient-icon-tomato" />
          </div>
        </div>
      </section>
    );
  }
}

export default Ingredients;



// WEBPACK FOOTER //
// ./src/components/Ingredients/Ingredients.js